import React, { useState } from "react";
import { Copy, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { copyToClipboard } from "@/lib/clipboard";

export default function CopyField({ label, value, testId, multiline = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    // iter 313 r17 — copyToClipboard funziona anche su iOS Safari (fallback
    // execCommand + Web Share). navigator.clipboard.writeText da solo spesso
    // falla su mobile per via di user-gesture timing.
    const result = await copyToClipboard(value ?? "", { shareTitle: label || "Copia" });
    if (result === "clipboard") {
      setCopied(true);
      toast.success("Copiato negli appunti");
      setTimeout(() => setCopied(false), 1500);
    } else if (result === "manual") {
      toast.error("Impossibile copiare. Seleziona e copia manualmente.");
    }
    // "share" → user ha gestito via OS share-sheet, nessun toast
  };

  return (
    <div className="flex items-start gap-3 py-3 border-b border-[#E5E7E0] last:border-b-0" data-testid={testId}>
      <div className="w-40 sm:w-44 flex-shrink-0 pt-1">
        {/* iter 312 r8 — label larga 160-176px così "CARATTERISTICHE" e
            "DESCRIZIONE COMPLETA" non overflowano nel box value. */}
        <span className="overline leading-tight block break-words">{label}</span>
      </div>
      <div className="flex-1 min-w-0">
        {multiline ? (
          <div className="whitespace-pre-wrap text-[15px] leading-relaxed text-[#1C1C1A]">{value || "—"}</div>
        ) : (
          <div className="text-[15px] text-[#1C1C1A] font-medium truncate">{value || "—"}</div>
        )}
      </div>
      <button
        onClick={copy}
        className="flex-shrink-0 w-10 h-10 flex items-center justify-center border border-[#E5E7E0] bg-white hover:bg-[#7C8B6E] hover:text-white hover:border-[#7C8B6E] transition-colors rounded-sm"
        title="Copia"
        data-testid={`${testId}-copy-btn`}
      >
        {copied ? <Check size={16} weight="bold" /> : <Copy size={16} weight="regular" />}
      </button>
    </div>
  );
}
